import SuccessfulController from './successful.component';


export default angular
  .module('fizyweb.paycell.student.successful', [])
  .component('successful', SuccessfulController).name;



// WEBPACK FOOTER //
// src/app/components/student/successful/successful.module.ts